import store from "../store";
import Constants from "../config/constants";
import LogUtils from "./LogUtils";

class RolesUtils {
    canAccess = (userRole, module, permissions) => {
        if (userRole) {
            const rolePermissions = userRole.permissions;
            const modulePermissions = rolePermissions.find(item => item.module === module);
            if (!modulePermissions) return false;
            return permissions.every(permission => modulePermissions[permission] === true);
        } else {
            return false;
        }
    }
};

export default new RolesUtils();
